<div class="container">
<mat-tab-group class="group" dynamicHeight>
    <mat-tab label="Global Connects tab">
       <app-admin></app-admin>
    </mat-tab>
    <mat-tab label="Local Connects tab">
    <app-local-connects></app-local-connects>
    </mat-tab>
  </mat-tab-group>
</div>